import React from 'react';
import "./Loader.css";
const Loader = () => {
    return (
        <div className="loader-container">
            <div class="loadingio-spinner-cube-m29t9w21eu"><div class="ldio-nv24sw08439">
                <div></div><div></div><div></div><div></div>
            </div></div>
        </div>
    );
};

export default Loader;